import Vue from 'vue'
import Router from 'vue-router'
import i18n from '@/helpers/i18n';

// Containers
const TheContainer = () => import('@/containers/TheContainer')

// Views
const Login = () => import('@/views/Login')
const PrivacyPolicy = () => import('@/views/PrivacyPolicy')
const Page404 = () => import('@/views/Page404');
const Page500 = () => import('@/views/Page500');

// Views - Pages
const SpeciesList = () => import('@/views/Species/SpeciesList')
const SpecieAdd = () => import('@/views/Species/SpecieAdd')
const SpecieEdit = () => import('@/views/Species/SpecieEdit')


Vue.use(Router)

export default new Router({
  mode: 'hash', // https://router.vuejs.org/api/#mode
  linkActiveClass: 'active',
  scrollBehavior: () => ({ y: 0 }),
  routes: configRoutes()
})

function configRoutes () {
  return [
    {
      path: '/',
      redirect: '/' + i18n.t('species'),
      name: 'Home',
      component: TheContainer,
      children: [
        {
          path: 'species',
          redirect: '/' + i18n.t('species') + '/' + i18n.t('list'),
          name: 'Species',
          component: {
            render (c) { return c('router-view') }
          },
          children: [
            {
              path: i18n.t('list'),
              name: 'SpeciesList',
              component: SpeciesList
            },
            {
              path: i18n.t('add'),
              name: 'SpecieAdd',
              component: SpecieAdd
            },
            {
              path: i18n.t('edit'),
              name: 'SpecieEdit',
              component: SpecieEdit
            },
          ]
        },

      ]
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      // Link from the password-reset e-mail: /#/reset-password?username=…&token=…
      path: '/reset-password',
      name: 'ResetPassword',
      component: Login
    },
    {
      path: '/privacypolicy',
      name: 'PrivacyPolicy',
      component: PrivacyPolicy
    },
    {
      path: '/404',
      name: '404',
      component: Page404
    },    
    {
      path: '/500',
      name: '500',
      component: Page500
    }, 
  ]
}

